const settings = {
	element: '.js-iframe-loader',
	loaderFor: 'data-loader-for'
};

export const init = () => {
	const loaders = document.querySelectorAll(settings.element);
	for (let i = 0; i < loaders.length; i++) {
		const loader = loaders[i];
		const iframe = document.querySelector(loader.getAttribute(settings.loaderFor));

		iframe.classList.add('d-none');
		loader.classList.remove('d-none');
		iframe.addEventListener(
			'load',
			() => {
				loader.classList.add('d-none');
				iframe.classList.remove('d-none');
			},
			{
				once: true
			}
		);
	}
}

init();
